import { render, staticRenderFns } from "./Marspark.vue?vue&type=template&id=72e9eeb0&scoped=true&"
import script from "./Marspark.vue?vue&type=script&lang=js&"
export * from "./Marspark.vue?vue&type=script&lang=js&"
import style0 from "./Marspark.vue?vue&type=style&index=0&id=72e9eeb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9eeb0",
  null
  
)

export default component.exports